import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ToasterService } from "@shared/services/toaster.service";
import { FE_CustomSimpleBot } from "@shared/models/admin-responses";
import { AdminCustomSimpleBotsApiService } from "@shared/services/admin/admin-custom-simple-bots-api.service";
import { AddCustomBotDialogContext, AdminAddCustomBotComponent } from "./add/add.component";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LogService } from "@shared/services/log.service";
import { SpinnerComponent } from "../../elements/spinner/spinner.component";
import { IboxComponent } from "../../elements/ibox/ibox.component";

import { UiSwitchModule } from "ngx-ui-switch";

@Component({
    templateUrl: "./custom-bots.component.html",
    styleUrls: ["./custom-bots.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SpinnerComponent, IboxComponent, UiSwitchModule, TranslatePipe]
})
export class AdminCustomBotsComponent implements OnInit {

    public isLoading = true;
    public bots: FE_CustomSimpleBot[];
    public isUpdating = false;

    constructor(
        private readonly botApi: AdminCustomSimpleBotsApiService,
        private readonly toaster: ToasterService,
        private readonly modal: NgbModal,
        public translate: TranslateService,
        private readonly logService: LogService,
    ) {
        this.translate = translate;
    }

    ngOnInit() {
        this.reload().then(() => this.isLoading = false).catch(error => {
            this.logService.error(error);
            this.translate.get('Error loading go-neb configuration').subscribe((res: string) => {
                this.toaster.pop("error", res);
            });
        });
    }

    private reload(): Promise<any> {
        return this.botApi.getBots().then(bots => {
            this.bots = bots;
            this.isLoading = false;
        });
    }

    public addBot() {
        const selfhostedRef = this.modal.open(AdminAddCustomBotComponent, {
            backdrop: 'static',
            size: 'lg',
        });
        selfhostedRef.result.then(async () => {
            try {
                await this.reload();
            } catch (err) {
                this.logService.error(err);
                this.translate.get('Failed to get an updated bot list').subscribe((res: string) => {
                    this.toaster.pop("error", res);
                });
            }
        });
    }

    public editBot(bot: FE_CustomSimpleBot) {
        const selfhostedRef = this.modal.open(AdminAddCustomBotComponent, {
            backdrop: 'static',
            size: 'lg',
        });
        selfhostedRef.result.then(async () => {
            try {
                await this.reload();
            } catch (err) {
                this.logService.error(err);
                this.translate.get('Failed to get an updated bot list').subscribe((res: string) => {
                    this.toaster.pop("error", res);
                });
            }
        });
        const selfhostedInstance = selfhostedRef.componentInstance as AddCustomBotDialogContext;
        selfhostedInstance.bot = bot;
        selfhostedInstance.isAdding = !bot;
    }

    public toggleBot(bot: FE_CustomSimpleBot) {
        this.isUpdating = true;
        bot.isEnabled = !bot.isEnabled;
        this.botApi.updateBot(bot.id, bot).then(() => {
            this.isUpdating = false;
            this.translate.get(['Enabled', 'disabled']).subscribe((res: string) => {
                this.toaster.pop("success", "Bot " + (bot.isEnabled ? res[0] : res[1]));
            });
        }).catch(error => {
            this.logService.error(error);
            bot.isEnabled = !bot.isEnabled;
            this.translate.get('Error updating bot').subscribe((res: string) => {
                this.toaster.pop("error", res);
            });
        })
    }
}
